var map = {
	"./apple.svg": 82,
	"./css3-alt.svg": 83,
	"./debian.svg": 84,
	"./github-square.svg": 46,
	"./html5.svg": 85,
	"./java.svg": 86,
	"./js-square.svg": 87,
	"./linux.svg": 88,
	"./node.svg": 89,
	"./python.svg": 90,
	"./react.svg": 91,
	"./swift.svg": 92,
	"./typescript.svg": 93,
	"./windows.svg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;